import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../colorVars';
import style from './DeleteButton.module.css';

export const DeleteButton = ({ size, backgroundColor, clickHandler }) => {
  return (
    <div
      className={style.container}
      style={{ width: size + 'px', height: size + 'px', backgroundColor }}
      onClick={clickHandler}
    >
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 473 473"
        style={{ enableBackground: 'new 0 0 473 473' }}
        xmlSpace="preserve"
        fill={colors.lightGrey}
      >
        <g>
          <path
            d="M324.285,215.015V128h20V38h-98.384V0H132.669v38H34.285v90h20v305h161.523c23.578,24.635,56.766,40,93.477,40
		c71.368,0,129.43-58.062,129.43-129.43C438.715,277.276,388.612,222.474,324.285,215.015z M294.285,215.015
		c-18.052,2.093-34.982,7.911-50,16.669V128h50V215.015z M162.669,30h53.232v8h-53.232V30z M64.285,68h250v30h-250V68z M84.285,128
		h50v275h-50V128z M164.285,403V128h50v127.768c-21.356,23.089-34.429,53.946-34.429,87.802c0,21.411,5.231,41.622,14.475,59.43
		H164.285z M309.285,443c-54.826,0-99.429-44.604-99.429-99.43s44.604-99.429,99.429-99.429s99.43,44.604,99.43,99.429
		S364.111,443,309.285,443z"
          />
          <polygon
            points="342.248,289.395 309.285,322.358 276.323,289.395 255.11,310.608 288.073,343.571 255.11,376.533 276.323,397.746 
		309.285,364.783 342.248,397.746 363.461,376.533 330.498,343.571 363.461,310.608 	"
          />
        </g>
      </svg>
    </div>
  );
};

DeleteButton.propTypes = {
  backgroundColor: PropTypes.any,
  clickHandler: PropTypes.any,
  size: PropTypes.number
};
